import { render, staticRenderFns } from "./VicrContextMenu.vue?vue&type=template&id=285e811e&"
import script from "./VicrContextMenu.vue?vue&type=script&lang=js&"
export * from "./VicrContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports